export const TerrenoArray =[
    {id:'P',display:'PROPIO'},
    {id:'R',display:'RENTADO'},
    {id:'E',display:'EJIDAL'},
    {id:'S',display:'SOCIEDAD'},
]